export default {
  actions: {
    activateCadasterLayer: 'View Cadaster Layer',
    minimize: 'Minimize',
    maximize: 'Maximize',
    openNewTab: 'Open in New Tab'
  },
  names: {
    image: 'Image',
    keywords: 'Related Searches',
    lateral: 'Lateral',
    map: 'Map',
    next: 'Next',
    panorama: 'Panorama',
    pointCloud: 'Point Cloud',
    previous: 'Previous',
    projection: 'Projection',
    tools: 'Tools',
    home: 'Home',
    baseMap: 'Base Map',
    moveForward: 'Move forward',
    moveBackwards: 'Move backwards',
    reproductionSpeed: 'Reproduction speed'
  },
  messages: {
    referenceNotFound: 'Reference not found',
    browserPopupBlocked: 'The browser has blocked the popup window. Allow popups for this site to synchronize administration and geoportal sessions.'
  },
  tools: {
    auth: {
      sessionNotStarted: 'No session has been started.',
      loggedToMapia: 'Successfully logged in to Mapia'
    },
    downloads: {
      headerName: 'Downloads',
      title: 'Download Center'
    },
    language: {
      headerName: 'Language'
    },
    opendata: {
      headerName: 'Open Data'
    },
    geovideos: {
      headerName: 'Geovideo',
      description: 'No video found at this point.',
      activateCenterMap: 'Center map',
      deactivateCenterMap: 'Deactivate centrer map',
      clickMapDescription: 'Click on the map to access georeferenced videos.',
      additionalInfo: 'Additional information',
      showAdditionalInfo: 'Show additional information',
      second: 'Second',
      stepForwardBackward: 'Move (m)',
      takePicture: 'Take picture'
    },
    panorama: {
      addAmbit: 'Ambit Layer',
      addAmbitCaption: 'Add a layer with the areas where there are panoramas',
      addLayer: 'Panorama Layer',
      addLayerCaption: 'Add a layer with points where there are panoramas',
      headerName: '3D Environment',
      title: 'Panoramas and Point Clouds',
      help: 'Click on the map to access panoramic view and point clouds obtained through mobile mapping.',
      centerMap: 'Center Map',
      noDataError: 'No data found at this location.',
      disablePano: 'Disable Panorama',
      enablePano: 'Enable Panorama',
      enablePanoDescription: 'Enable/disable the panorama viewer',
      enableLateral: 'Enable Lateral Image',
      disable3D: 'Disable 3D',
      enable3D: 'Enable 3D',
      enable3DDescription: 'Enable/disable the point cloud viewer',
      unsync3D: 'Unsync 3D',
      sync3D: 'Sync 3D',
      openPano: 'Open Panorama',
      openPanoCaption: 'Open the panorama in another window',
      openPointCloud: 'Open Point Cloud',
      openPointCloudCaption: 'Open the point cloud in another window',
      rotateLeft: 'Rotate panorama 90º to the left',
      rotate180: 'Rotate panorama 180º',
      rotateRight: 'Rotate panorama 90º to the right',
      mustLogin: 'Log in to view panoramas',
      infoCampaign: 'Active campaign Information',
      descriptionCampaign: 'Campaign Description',
      zoneCampaign: 'Zone',
      dateCampaign: 'Campaign dates',
      startCampaign: 'Start Campaign',
      endCampaign: 'End Campaign',
      drawingNavigationPanel: 'Automatic navigation',
      drawingNavigationPanelDescription: 'Open the automatic navigation window',
      generateNewRoute: 'Generate new route',
      playlist: 'Playlist',
      reversePlaylist: 'Reverse route direction',
      removePlaylist: 'Delete the route',
      drawingNavigationPanelInfo: 'Draw a line to generate the route you want to navigate. Double click to stop drawing.',
      drawingNavigationPanelInfo2: 'Click on "Generate new route" to draw on the map the route you want to navigate.',
      drawingNavigationPanelInfo3: 'Click the "Play" button to start the route.',
      playPlaylist: 'Navigate the route',
      stopPlaying: 'Stop playback',
      timePerPoint: 'Time per point in seconds',
      stepBetweenPoints: 'Step between points'
    },
    addCustomLayer: {
      headerName: 'Add Layer',
      title: 'Add Custom Layer',
      layerFormat: 'Choose new layer format',
      layerFormatOptions: [
        'WMS',
        'TMS',
        'GeoJSON',
        'GML'
      ],
      layerName: 'Enter layer name',
      layerURL: 'Enter layer or service URL',
      properties: 'Properties',
      layerWMSLayers: 'Specify WMS layers: layer1, layer2, ...',
      layerWMSLayersHint: 'Use a comma to separate each layer.',
      layerProjection: 'Projection:',
      layerWMSSingleImage: 'Load WMS without tiling, using a single image',
      layerTMSInvert: 'Invert tiles on the Y axis',
      geojsonColor: 'Select line color',
      geojsonFillColor: 'Select fill color',
      geojsonWeight: 'Thickness',
      geojsonWeightHint: 'Numbers only',
      geojsonOpacity: 'Opacity',
      geojsonOpacityHint: 'Only numbers from 0 to 1',
      addButton: 'Add layer to map'
    },
    panoramasIncidence: {
      requiredField: 'Required field',
      descriptionMissing: 'if incidence type is "Other" a description is required',
      notifyIncidence: 'Notify incidence',
      incidenceType: 'Incidence type',
      incidenceOptions: [
        'Sensible information not blurred',
        'Error in the spherical image',
        'Error in the point cloud',
        'Orientation image/point cloud not matching',
        'Other'
      ]
    }
  },
  search: {
    advanced: {
      title: 'Advanced search',
      optionsLabel: 'Select type of search',
      layers: 'Catalog layers',
      address: 'Address',
      addressICGC: 'Address (ICGC)',
      municipality: 'Municipality (optional)',
      refcad: 'Cadastral reference',
      refcadHint: 'The cadastral reference must have 7, 14 or 20 digits',
      coordinates: 'Coordinates',
      pkFerroviariICGC: 'Railway milestone (ICGC)',
      pkFerroviariSearchLabel1: 'Milestone (Ex: 50)',
      pkFerroviariSearchLabel2: 'Milestone (Ex: 50.2)',
      pkFerroviariHint: 'Enter the range of milestones you want to search (e.g. 50 - 50.2)',
      pkICGC: 'Milestone (ICGC)',
      layerSearchLabel: 'Layer name',
      search: 'Search',
      roadSearchLabel: 'Road (Ex: AP-7)',
      pkSearchLabel: 'Kilometric point (Ex: 123)',
      epsgLabel: 'SRS',
      latitude: 'Latitude',
      longitude: 'Longitude',
      x: 'X',
      y: 'Y',
      street: 'Street',
      streetNumber: 'Number'
    }
  }
}
